export enum CancelationReason {
  GuideProblem = 1,
  Duplicated = 2,
  Fraudulent = 3,
  CustomerRequest = 4
};